<mat-sidenav-container>
  <mat-sidenav class='sidenav' align='start' [opened]='true' [mode]='sidenavMode' meeIconSidenav #sidenav>
    <mee-sidenav></mee-sidenav>
  </mat-sidenav>

  <div class='main-container' #scrollContainer>
    <router-outlet (activate)='onActivate($event, scrollContainer)'></router-outlet>
  </div>
</mat-sidenav-container>

<div
  class='dropdown'
  [class.opened]='isDropdownOpened'
  meeMisclick
  (isInClick)='closeOnMisclick($event)'
  [trackSelectors]='[dropdownTrigger]'
>
  <div class='top'>
    <h5 class='title'>{{ 'global-forms.add' | translate }}</h5>
    <mat-icon (click)='close($event)'>close</mat-icon>
  </div>

  <ul>
    <li>
      <a (click)='createUser($event)' class='item'>
        <mat-icon>person</mat-icon>
        <span class='text'>{{ 'global-forms.dropdown.admin' | translate }}</span>
      </a>
    </li>
    <li *ngIf='isShowProjectCreateButton'>
      <a (click)='createProject($event)' class='item'>
        <mat-icon svgIcon="project-icon"></mat-icon>
        <span class='text'>{{ 'global-forms.dropdown.project' | translate }}</span>
      </a>
    </li>
    <li *ngIf='isShowDataSourceCreateButton'>
      <a (click)='createDataSource($event)' class='item'>
        <mat-icon>settings_ethernet</mat-icon>
        <span class='text'>{{ 'global-forms.dropdown.dataSource' | translate }}</span>
      </a>
    </li>
    <li class="separator">
      <p>{{ 'global-forms.dropdown.separator-components' | translate }}</p>
    </li>
    <li *ngIf='isShowMapCreateButton'>
      <a (click)='createBasemap($event)' class='item'>
        <mat-icon>map</mat-icon>
        <span class='text'>{{ 'global-forms.dropdown.baseMap' | translate }}</span>
      </a>
    </li>
    <li *ngIf='isShowDtmCreateButton'>
      <a (click)='createDTM($event)' class='item'>
        <div class='dtm-icon dropdown-icon'></div>
        <span class='text'>{{ 'global-forms.dropdown.dtm' | translate }}</span>
      </a>
    </li>
    <li *ngIf='isShowLayerCreateButton'>
      <a (click)='createLayer($event)' class='item'>
        <mat-icon>layers</mat-icon>
        <span class='text'>{{ 'global-forms.dropdown.layer' | translate }}</span>
      </a>
    </li>
    <li class="separator">
      <p>{{ 'global-forms.dropdown.separator-other' | translate }}</p>
    </li>
    <li>
      <a class='item' (click)="createQrCode($event)">
        <div class="qrcode-icon dropdown-icon"></div>
        <span class='text'>{{ 'global-forms.dropdown.qr-codes' | translate }}</span>
      </a>
    </li>
  </ul>
</div>
